import { ApplicationError } from "@rocicorp/zero";

/**
 * Mutation or validation failure safe to show verbatim in a toast (see
 * `classifyZeroResult` in `services/ui/lib/zeroResultError.ts`).
 */
export function userFacingError(
  message: string,
  extra?: Record<string, unknown>
): ApplicationError {
  return new ApplicationError(message, {
    details: { userFacing: true, ...extra },
  });
}
